apiDateFilter.$inject = ['$filter'];
function apiDateFilter($filter) {
    return function (date) {
        return $filter('date')(date, 'yyyy-MM-dd');
    }
}

export default apiDateFilter